import { Drawer, Icon, Card, Tag, Form, Radio, Select, Input, Button, notification } from "antd";
import React from "react";
import { connect } from "react-redux";
import _ from 'lodash';
import Request from "../../request";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const RadioGroup = Radio.Group;
const Option = Select.Option

@Form.create()
class AddCallRegisterDetails extends React.Component {
    state = {
        visible: true,
        FromType: 'Student',
        allUsers: [],
        loading: false,
        phoneCodes: []
    }

    onClose = () => {
        const { form } = this.props;
        form.resetFields();
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }

    handleSubmit = (e) => {
        const { dispatch, form } = this.props
        const { studentData } = this.state
        e.preventDefault();

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                if (values.fromType === 'Student' && studentData) {
                    values.name = studentData && studentData.studentName
                    values.phoneNo = studentData && studentData.phoneNo
                    values.email = studentData && studentData.emailId
                    values.vid = studentData && studentData.id
                    values.studentId = studentData && studentData._id
                    values.countryCode = studentData && studentData.countryCode
                } else {
                    values.vid = 0
                }
                this.setState({ loading: true });
                let response = await Request.addDetailInCallRegister(values);
                this.setState({ loading: false });
                if (response.success) {
                    notification.success({
                        message: response.message
                    })
                } else {
                    notification.error({
                        message: response.message
                    })
                }
                this.onClose();
            }
        })
    }

    loadUsers = (params, userType = 'user') => {
        return new Promise(async resolve => {
            if (!params) {
                params = {}
            }
            params.sortField = 'dateOfJoining'
            params.sortOrder = 'ascend'
            params.active = true
            params.count = 500;
            params.results = 100;
            params.userType = { $ne: "Student" }
            let data = await Request.loadEmployeeUser({ ...params, regExFilters: ['name', 'email'] })
            this.setState({ totalUser: data.total, allUsers: data.data })
        })
    }

    loadCountries = () => {
        Request.getCountriesWithoutAuth({
            results: 200,
            sortField: 'countryName',
            sortOrder: 'ascend',
            businessId: activeUser && activeUser.businessId
        })
            .then(resp => {
                let phoneCodes = [];
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.countryName });
                    if (vv.countryPhoneCode) {
                        phoneCodes.push(vv.countryPhoneCode);
                    }
                    return temp
                }, [])

                this.setState({ countriesData: resp.data, phoneCodes: phoneCodes });
            })
            .catch(err => {
                console.log(err)
            })
    }


    componentDidMount() {
        this.loadUsers();
        this.loadCountries();
        // let response = await Request.
    }


    render() {
        let { visible, FromType, filteredData, allUsers, phoneCodes } = this.state;
        let { form: { getFieldDecorator, setFieldsValue } } = this.props;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
                md: { span: 8 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
                md: { span: 12 }
            }
        }
        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '95%' }}>
                        <span>
                            <Icon type="user-delete" style={{ marginRight: 10, color: '#ef4444' }} />
                            Add Call Detail
                        </span>
                        <Tag
                            className="bg-red"
                            style={{
                                border: '1px solid #ef4444',
                                borderRadius: '4px',
                                fontWeight: 700,
                                padding: '0 12px'
                            }}
                        >
                            Add Call Detail
                        </Tag>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={800}
            >
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Item {...formItemLayout} label="From"> {getFieldDecorator('fromType', {
                            rules: [{ required: true }]
                        })(
                            <RadioGroup

                                options={['Student', 'Other']}
                                required={true}
                                onChange={v => {
                                    this.setState({ FromType: v.target.value })
                                    this.props.form.setFieldsValue({
                                        fromType: v.target.value
                                    })
                                }}
                                value={FromType}
                            />
                        )}
                        </Form.Item>
                        {FromType && FromType === 'Student' ?
                            <Form.Item {...formItemLayout} label="Name"> {getFieldDecorator('studentName', {
                                rules: [{ required: true }]
                            })(<Select
                                showSearch
                                allowClear
                                style={{
                                    width: 440,
                                    marginRight: '10px'
                                }}
                                value={this.state.searchvalueId}
                                placeholder={`Search Student by Name, DOB (${dateFormat}), Mobile or Email ID`}
                                filterOption={false}
                                onSearch={async (test) => {
                                    this.setState({
                                        searchLoading: true
                                    })
                                    let { data } = await Request.searchStudentFilteredData({ test })

                                    this.setState({ filteredData: data, searchLoading: false })
                                }}
                                onChange={id => {

                                    let foundstudentData = _.find(filteredData, (item) => {
                                        return item._id === id

                                    })
                                    this.setState({ searchvalueId: id, studentData: foundstudentData }, () => {
                                        console.log('e')
                                    })
                                }}
                            >
                                {filteredData &&
                                    filteredData.map((val, idn) => {
                                        return (
                                            <Option key={idn}
                                                value={val._id}>{`${val.studentName} (${val.id}) - ${val.phoneNo}`}</Option>
                                        )
                                    })}
                            </Select>)}</Form.Item> :
                            <React.Fragment><Form.Item {...formItemLayout}
                                label="Name">{getFieldDecorator('name', {
                                    rules: [{ required: true }]
                                })(
                                    <Input style={{ width: 440 }} />
                                )}</Form.Item>

                                {/* <Form.Item {...formItemLayout} label="Email">{getFieldDecorator('email', {
                                    rules: [{ required: true }]
                                })(
                                    <Input style={{ width: 440 }} />
                                )}</Form.Item> */}
                                <Form.Item {...formItemLayout}
                                    label="Country Code">{getFieldDecorator('countryCode', {
                                        rules: [{ required: true }]
                                    })(
                                        <Select
                                            allowClear
                                            style={{ width: '440px' }}
                                            showSearch={true}
                                            value={this.state.countryCode}
                                            onChange={countryCode => this.setState({ countryCode: countryCode && countryCode.toString() })}
                                        >
                                            {
                                                phoneCodes.map((val, idn) => (
                                                    <Option key={idn} value={val}>
                                                        {val}
                                                    </Option>
                                                ))
                                            }
                                        </Select>
                                    )}</Form.Item>
                                <Form.Item {...formItemLayout} label="Phone No">{getFieldDecorator('phoneNo', {
                                    rules: [{ required: true }]
                                })(
                                    <Input style={{ width: 440 }} />
                                )}</Form.Item>

                            </React.Fragment>}
                        <Form.Item {...formItemLayout} label="Employee Name"> {getFieldDecorator('employeeId', {
                            rules: [{ required: true }]
                        })(
                            <Select
                                allowClear
                                style={{ width: '440px' }}
                                showSearch={true}
                                value={this.state.employeeId}
                                placeholder="Select Option"
                                optionFilterProp="name"
                                required={true}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    )
                                }}
                                onChange={employeeId => this.setState({ employeeId: employeeId && employeeId.toString() })}
                            >
                                {allUsers.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val._id}>
                                            {val.name}
                                        </Option>
                                    )
                                })}
                            </Select>
                        )}
                        </Form.Item>
                        <Form.Item {...formItemLayout} label="Call Status"> {getFieldDecorator('callStatus', {
                            rules: [{ required: true }]
                        })(
                            <Select
                                allowClear
                                style={{ width: '440px' }}
                                showSearch={true}
                                value={this.state.employeeId}
                                placeholder="Select Option"
                                optionFilterProp="name"
                                required={true}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    )
                                }}
                                onChange={callStatus => this.setState({ callStatus: callStatus && callStatus.toString() })}
                            >
                                <Option value={"Connected"}>Connected</Option>
                                <Option value={"Not Connected"}>Not Connected</Option>
                            </Select>
                        )}
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={this.state.loading}>
                                Save </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}


const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)
    (AddCallRegisterDetails)